import { Theme } from "@material-ui/core"
import type { ISourceOptions } from "tsparticles-engine"
import { BackgroundType } from "../contexts/SettingsProvider"

export function getBackgroundParticles(type: BackgroundType, theme: Theme): ISourceOptions {
    const primary = theme.palette.primary.main
    const base: ISourceOptions = {
        fullScreen: { enable: true, zIndex: -1 },
        background: { color: { value: "transparent" } },
        detectRetina: true,
        fpsLimit: 60,
    }

    switch (type) {
        case BackgroundType.Snow:
            return { ...base, particles: { number: { value: 0 } } }
        case BackgroundType.Connected:
            return {
                ...base,
                particles: {
                    color: { value: primary },
                    links: {
                        enable: true,
                        color: primary,
                        distance: 150,
                        opacity: 0.4,
                    },
                    move: { enable: true, speed: 1 },
                    number: {
                        value: 35,
                        density: { enable: true, area: 1000 },
                    },
                },
            }
        case BackgroundType.Stars:
            return { ...base, particles: { number: { value: 0 } } }
        case BackgroundType.FallLeaves:
            return { ...base, particles: { number: { value: 0 } } }
        case BackgroundType.Bubbles:
            return { ...base, particles: { number: { value: 0 } } }
        case BackgroundType.City:
            return { ...base, particles: { number: { value: 0 } } }
        default:
            return { ...base, particles: { number: { value: 0 } } }
    }
}
